export default __webpack_public_path__ + "static/media/locked.9a92ac3e.svg";